const NAME = "TYPES_OF_PUBLICATION_FORMATS";

export default NAME;
